export const enClientPortalOrderManagementSidebarPages = {
    orders: {
        orderManagementSidebar: {
            orderList: 'Order list',
        },
    },
}
